import React from 'react'
import { getFirstCharacters } from '../../helpers/utils'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface AvatarProps {
    name: string | undefined
    className?: string
    invert?: boolean
}

const Avatar: React.FunctionComponent<AvatarProps> = ({ name, className, invert }: AvatarProps) => {
    const avatarClass = invert
        ? 'bgBlushPrimaryColor ccText font-medium'
        : 'bg-[--tb-primary] text-white border-[--tb-primary] font-semibold '
    return (
        <span
            className={`flex-shrink-0 flex items-center border-full justify-center uppercase rounded-full w-10 h-10 ${avatarClass} ${className}`}
        >
            {name ? getFirstCharacters(name) : <DynamicFaIcon iconName='user' />}
        </span>
    )
}

export default Avatar
